import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_GET_DP_BASE_URL}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  const storedToken = localStorage.getItem("u_token");
  return {
    headers: {
      ...headers,
      authorization: storedToken ? `Bearer ${JSON.parse(storedToken)}` : "",
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  fetchOptions: {
    mode: 'no-cors',
  },
  cache: new InMemoryCache(),
});

export default client;
